export default __webpack_public_path__ + "static/media/fw-emma-er-Rose Gold.8df6cd57.mp4";